import { useAtom } from 'jotai';
import { isDarkModeAtom } from './DarkModeAtom';

export const useConfigDarkMode = () => {
    return useAtom(isDarkModeAtom);
};
